import { Injectable } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ComingSoonInterestEvent } from '../../components/payrolladmin/coming-soon-upsell/coming-soon-upsell.types';
import { ComingSoonInterestEventsService } from '../coming-soon-interest-events/coming-soon-interest-events.service';

export interface ComingSoonUpsellServiceOptions {
  metadata?: Record<string, unknown>;
}

@Injectable({ providedIn: 'root' })
export class ComingSoonUpsellService {
  private metadata: Record<string, unknown> | null = null;

  constructor(private comingSoonInterestEventsService: ComingSoonInterestEventsService) {}

  configure(options: ComingSoonUpsellServiceOptions): void {
    if (options && options.metadata) {
      this.metadata = options.metadata;
    }
  }

  submitInterest(payload: ComingSoonInterestEvent): Observable<boolean> {
    return from(this.comingSoonInterestEventsService.create({
      featureKey: payload.featureKey,
      interestType: payload.type,
      email: payload.email,
      message: payload.message,
      eventTimestamp: payload.timestampIso,
      timestampIso: payload.timestampIso,
      context: payload.context as Record<string, any> | undefined,
      metadata: this.metadata as Record<string, any> | undefined,
    })).pipe(
      map(() => true),
      catchError((err) => {
        // eslint-disable-next-line no-console
        console.warn('[ComingSoonUpsell] submit failed:', err);
        return of(false);
      })
    );
  }
}
